;(function (angular, _, numeral, moment) {
  'use strict'

  angular
    .module('kilo.routes.inbox.list')
    .controller('InboxListController', InboxListController)

  InboxListController.$inject = [
    // Managers
    'InmailManager',

    // Services
    'ColumnService', 'SelectionService', 'PreferencesService',
    'FilterSidebarService', 'DatePickerService',

    // Resolve
    'pagination'

  ]

  function InboxListController (
    // Angular
    InmailManager,

    // Services
    ColumnService, SelectionService, PreferencesService,
    FilterSidebarService, DatePickerService,

    // Resolve
    pagination

  ) {
    var self = this

    var customRanges = [
      {
        label: '3 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
      },
      {
        label: '6 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
      },
      {
        label: '1 an',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
      },
      {
        label: '2 ans',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
      }
    ]

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        sideBar: FilterSidebarService,

        // Methods
        getList: getList,
        isVisible: isVisible,
        sort: sort,
        selectDateRange: selectDateRange,
        dropColumn: dropColumn,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        resetDateRange: resetDateRange
      })

      init()
    }

    function init () {
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
        self.columns = ColumnService.getColumns('inmail')
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.inboxList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.inboxList, 'pagination')
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
          }
        }
        self.selection.selectedData = []
        getList()
      })
    }

    function saveColumns () {
      self.prefs.settings.inboxList.columns = self.columns
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('inmail')
      })
    }

    function resetColumns () {
      self.prefs.settings.inboxList.columns = ColumnService.getDefaultColumns('inmail')
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('inmail')
      })
    }

    function dropColumn (source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('inmail')
      })
    }

    function getList () {
      var query
      if (_.get(self, 'pagination.search') && _.get(self, 'pagination.search.date')) {
        self.isSearch = true
        var start = new Date(self.pagination.search.date.start)
        var end = new Date(self.pagination.search.date.end)
        query = InmailManager.query({
          conditions: {
            'createdAt': {
              $lte: end,
              $gte: start
            }
          }
        })
      } else {
        self.isSearch = false
        query = InmailManager.query()
      }

      query = query.paginate(self.pagination.toQueryOptions())
      if (_.get(self, 'pagination.search')) {
        if (_.get(self, 'pagination.search.title')) {
          self.isSearch = true
          query = query.search(_.get(self, 'pagination.search.title'), 'raw.title')
        }
      }
      self.loading = true
      InmailManager.get(query).then(function (data) {
        self.inmails = data.data
        self.pagination.totalElements = data.meta.total
        self.loading = false
      })
    }

    function selectDateRange () {
      DatePickerService.getRange(self.pagination.search.date, { showRanged: true, customSelectOptions: customRanges }).then(function (dates) {
        self.pagination.search.date = dates
        self.rangeDate = 'Du ' + moment(self.pagination.search.date.start).format('DD/MM/YYYY') + ' au ' + moment(self.pagination.search.date.end).format('DD/MM/YYYY')
        getList()
      })
    }

    function resetDateRange () {
      delete self.pagination.search.date
      delete self.rangeDate
      getList()
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function isVisible (columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }
  }
})(window.angular, window._, window.numeral, window.moment)
